import { useFetch } from '#/hooks/use-fetch';
import { ENV } from '#/data/constants';

export function useBareunService(): PackageService {
  const client = useFetch();

  return {
    getAnalyze: async (
      apiKey,
      auto_split_sentence,
      auto_spacing,
      auto_jointing,
      custom_domain,
      encoding_type,
      document
    ) => {
      return await client.postApiKey(
        `https://${ENV.GRPC_BAREUN_ADDRESS}/bareun.LanguageService/AnalyzeSyntax`,
        apiKey,
        {
          auto_split_sentence: auto_split_sentence,
          auto_spacing: auto_spacing,
          auto_jointing: auto_jointing,
          custom_domain: custom_domain,
          encoding_type: encoding_type,
          document: document
        }
      );
    },
    getTokenize: async (
      apiKey,
      auto_split_sentence,
      auto_spacing,
      encoding_type,
      document
    ) => {
      return await client.postApiKey(
        `https://${ENV.GRPC_BAREUN_ADDRESS}/bareun.LanguageService/Tokenize`,
        apiKey,
        {
          auto_split_sentence: auto_split_sentence,
          auto_spacing: auto_spacing,
          encoding_type: encoding_type,
          document: document
        }
      );
    }
  };
}

interface PackageService {
  getAnalyze: (
    apiKey: string,
    auto_split_sentence: boolean,
    auto_spacing: boolean,
    auto_jointing: boolean,
    custom_domain: string,
    encoding_type: number,
    document: { content: string; language: string }
  ) => Promise<any>;
  getTokenize: (
    apiKey: string,
    auto_split_sentence: boolean,
    auto_spacing: boolean,
    encoding_type: number,
    document: { content: string; language: string }
  ) => Promise<any>;
}
